import { getStore } from '../store/store';

export function getShouldShowCopilotAutoReschedulingNotificationsCallout(): boolean {
    return getStore().shouldShowCopilotAutoReschedulingNotificationsCallout || false;
}
